import { render, staticRenderFns } from "./addALiForm.vue?vue&type=template&id=0fc9de5b&scoped=true"
import script from "./addALiForm.vue?vue&type=script&lang=js"
export * from "./addALiForm.vue?vue&type=script&lang=js"
import style0 from "./addALiForm.vue?vue&type=style&index=0&id=0fc9de5b&prod&lang=scss&scoped=true"


/* normalize component */
import normalizer from "!../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "0fc9de5b",
  null
  
)

export default component.exports